import { ExtractedEntity } from '../_types';

export function deduplicateAndFilterOverlapping(
  entities: ExtractedEntity[]
): ExtractedEntity[] {
  const seen = new Map<string, ExtractedEntity>();
  entities.forEach((entity) => {
    const key = `${entity.start_position}-${entity.end_position}`;
    if (!seen.has(key)) {
      seen.set(key, entity);
    }
  });

  const deduplicated = Array.from(seen.values());
  deduplicated.sort((a, b) => a.start_position - b.start_position);

  const nonOverlapping: ExtractedEntity[] = [];
  let lastEndPosition = -1;

  deduplicated.forEach((entity) => {
    if (entity.start_position >= lastEndPosition) {
      nonOverlapping.push(entity);
      lastEndPosition = entity.end_position;
    }
  });

  return nonOverlapping;
}

export default function highlightNamesWithEntities(
  text: string,
  entities: ExtractedEntity[],
  enableDropdowns: boolean = false
): string {
  if (!text || !enableDropdowns || entities.length === 0) {
    return text;
  }

  const personEntities = entities.filter(
    (e) => e.extraction_class_key.toLowerCase() === 'person'
  );
  const cleanedEntities = deduplicateAndFilterOverlapping(personEntities);

  let result = text;
  cleanedEntities
    .sort((a, b) => b.start_position - a.start_position)
    .forEach((entity) => {
      const extractedName = result.slice(
        entity.start_position,
        entity.end_position
      );

      if (extractedName !== entity.extraction_text) return;

      const before = result.slice(0, entity.start_position);
      const after = result.slice(entity.end_position);
      const displayName = entity.profile?.full_name || extractedName;

      const escapedName = extractedName
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

      const profileId = entity.profile?.id || '';
      const hasProfile = entity.profile !== null ? 'true' : 'false';

      result = `${before}<span class="highlighted-name" data-name="${escapedName}" data-profile-id="${profileId}" data-has-profile="${hasProfile}" data-start-position="${entity.start_position}" data-entity-id="${entity.id}">${displayName}</span>${after}`;
    });

  return result;
}
